import {
  apiV2EnergyResilienceConfigGasPagePost,
  apiV2EnergyResilienceConfigGasPlantQueryPost,
  apiV2EnergyResilienceConfigLinePagePost,
} from '@maxtropy/device-customer-apis-v2';
import { MediumType, ResilienceRecord } from '../types';
import { FetchRecordsParams } from './types';

export const fetchConfigRecords = async ({
  activeEnergy,
  currentDimension,
  currentMediumType,
  currentScope,
  filters,
  isFactory,
  pageOffset,
  pageSize,
}: FetchRecordsParams): Promise<{ records: ResilienceRecord[]; total: number }> => {
  if (activeEnergy === MediumType.Electricity) {
    const res = await apiV2EnergyResilienceConfigLinePagePost({
      page: pageOffset,
      size: pageSize,
      codeOrName: filters.codeOrName as string,
      circuitStart: filters.circuitStart as string,
      circuitEnd: filters.circuitEnd as string,
    });
    return {
      records: (res?.list ?? []).map(item => ({
        ...item,
        id: item.id ?? 0,
        energy: activeEnergy,
        scope: currentScope,
        circuitKey: item.circuitCode ?? item.circuitName,
      })),
      total: res?.total ?? 0,
    };
  }

  if (isFactory) {
    const item = await apiV2EnergyResilienceConfigGasPlantQueryPost({ mediumType: currentMediumType });
    return {
      records: [
        {
          id: item?.id ?? 0,
          energy: activeEnergy,
          scope: currentScope,
          ratedFlow: item?.ratedFlowRate,
          flowMeters: item?.flowMeters,
          flowMeterDeviceIds: item?.flowMeters?.map(meter => meter.deviceId ?? 0),
        },
      ],
      total: 1,
    };
  }

  const res = await apiV2EnergyResilienceConfigGasPagePost({
    page: pageOffset,
    size: pageSize,
    mediumType: currentMediumType,
    dimension: currentDimension,
    codeOrName: (filters.stationName || filters.areaName || filters.outletName || filters.compressorName) as string,
    gasSourceName: Array.isArray(filters.gasSources) ? String(filters.gasSources[0]) : (filters.gasSources as string),
  });
  return {
    records: (res?.list ?? []).map(item => ({
      ...item,
      id: item.id ?? 0,
      energy: activeEnergy,
      scope: currentScope,
      ratedFlow: item.ratedFlowRate ?? item.ratedFlowSpeed,
      gasSources: item.gasSources,
      flowMeters: item.flowMeters,
      flowMeterDeviceIds: item.flowMeters?.map(meter => meter.deviceId ?? 0),
    })),
    total: res?.total ?? 0,
  };
};
